
import React from "react";
import Header from "../components/home/Header";

import Footer from "../components/home/Footer";
import WorkSub from "../components/ourwork/WorkSub";

function WorkSubPage() {
  return (
    <div>
      <Header />
      <WorkSub />
      <Footer />
    </div>
  );
}

export default WorkSubPage;
